export const detection = {
  data() {
    return {

      isChecking: false,
      stream: null,
    };
  },
  computed: {},
  created() {},
  mounted() {},


  beforeDestroy() {
    this.releaseCamera();
  },

  beforeUnmount() {
    this.releaseCamera();
  },
  methods: {
    /**
     * 检测浏览器是否支持媒体设备
     */
    checkMediaSupport() {
      if (!navigator.mediaDevices) {
        this.$toast.error('您的浏览器不支持媒体设备访问');
      }
      if (!navigator.mediaDevices.getUserMedia) {
        this.$toast.error('您的浏览器不支持摄像头访问');
      }
      return true;
    },

    /**
     * 检查摄像头权限状态
     * @returns {Promise<'granted'|'prompt'|'denied'>} 权限状态
     */
    async checkCameraPermission() {
      try {
        if (navigator.permissions && navigator.permissions.query) {
          const permissionStatus = await navigator.permissions.query({
            name: 'camera'
          });
          return permissionStatus.state;
        }
        return 'unknown';
      } catch (err) {
        return 'unknown';
      }
    },

    /**
     * 请求摄像头权限
     * @returns {Promise<MediaStream>}
     */
    async requestCameraPermission() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: {
              ideal: 1280
            },
            height: {
              ideal: 720
            },
            frameRate: {
              ideal: 30
            },
            facingMode: "user"
          },
          audio: false
        });
        return stream;
      } catch (err) {
        throw err;
      }
    },

    /**
     * 释放摄像头资源
     */
    releaseCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
    },

    /**
     * 检测是否为永久拒绝
     */
    async isPermanentlyDenied() {
      // ✅ 不再调用 getUserMedia，只检查权限状态
      const state = await this.checkCameraPermission();
      return state === 'denied';
    },
    // async isPermanentlyDenied() {
    //   try {
    //     // 尝试再次请求，如果立即失败且没有弹窗，说明是永久拒绝
    //     await navigator.mediaDevices.getUserMedia({
    //       video: true
    //     });
    //     return false;
    //   } catch (err) {
    //     if (err.name === 'NotAllowedError') {
    //       // 再次检查权限状态
    //       const state = await this.checkCameraPermission();
    //       return state === 'denied';
    //     }
    //     return false;
    //   }
    // },

    /**
     * 进入采集页面
     */
    async enterCollectionPage() {
      try {
        this.releaseCamera();
        // this.$toast.success("开始健康扫描");
        console.log('开始健康扫描')
        this.type = 2
      } catch (err) {
        console.error('进入采集页面失败:', err);
        this.$toast.error('跳转失败，请重试');
      } finally {
        this.isChecking = false;
      }
    },

    /**
     * 开始按钮点击处理
     */
    async handleStart() {
      if (this.isChecking) return;

      try {
        // 步骤1: 检测浏览器支持
        this.isChecking = true;
        this.checkMediaSupport();

        // 步骤2: 检查摄像头权限状态
        const permissionState = await this.checkCameraPermission();

        // 步骤3: 根据权限状态执行不同逻辑
        if (permissionState === 'granted') {
          // 已授权 - 直接进入采集页面
          await this.enterCollectionPage();

        } else if (permissionState === 'denied') {
          // 已拒绝 - 检查是否永久拒绝
          const permanentlyDenied = await this.isPermanentlyDenied();

          if (permanentlyDenied) {
            // 永久拒绝 - 弹出禁止使用弹窗
            this.$pop.open(
              "摄像头禁止使用",
              "请到浏览器设置中，取消摄像头开启限制"
            );
          } else {
            // 临时拒绝 - 重新请求权限
            try {
              const stream = await this.requestCameraPermission();
              this.stream = stream;
              await this.enterCollectionPage();
            } catch (err) {
              this.$toast.error('您已拒绝摄像头权限，请重新点击开始按钮授权');
            }
          }
          this.isChecking = false;

        } else {
          // prompt 或 unknown - 请求权限
          try {
            const stream = await this.requestCameraPermission();
            this.stream = stream;
            await this.enterCollectionPage();
          } catch (err) {
            // 请求被拒绝
            if (err.name === 'NotAllowedError') {
              // 检查是否永久拒绝
              const permanentlyDenied = await this.isPermanentlyDenied();

              if (permanentlyDenied) {
                // 永久拒绝 - 弹出禁止使用弹窗
                this.$pop.open(
                  "摄像头禁止使用",
                  "请到浏览器设置中，取消摄像头开启限制"
                );
              } else {
                // 临时拒绝 - 停留在当前页，可重试
                this.$toast.error('您已拒绝摄像头权限，请重新点击开始按钮授权');
              }
            } else if (err.name === 'NotFoundError') {
              this.$toast.error('未检测到摄像头设备，请检查硬件连接');
            } else if (err.name === 'NotReadableError') {
              this.$toast.error('摄像头被其他应用占用，请关闭后重试');
            } else {
              const msg = err.message || '摄像头启动失败，请稍后重试';
              this.$toast.error(msg);
            }
            this.isChecking = false;
          }
        }

      } catch (err) {
        console.error('启动流程错误:', err);
        this.isChecking = false;
        this.$toast.error('摄像头启动失败，请稍后重试');
      }
    }
  },
};